import { createSlice } from "@reduxjs/toolkit"

const playerSlice = createSlice({
    name: 'player',
    initialState: {
        field: [],
        ships: [],
        shipsStats: {
            1: 4,
            2: 3,
            3: 2,
            4: 1
        }
    },
    reducers: {
        createField: (state, action) => {
            state.field = action.payload;
        },
        addShips: (state, action) => {
            state.ships = action.payload;
        },
        shot: (state, action) => {
            state.field[+action.payload].visual = 'shot';
        },
        hit: (state, action) => {
            state.field[+action.payload].visual = 'hit';
        },
        miss: (state, action) => {
            state.field[+action.payload].visual = 'miss';
        },
        mark: (state, action) => {
            state.field[+action.payload].visual = 'mark';
        },
        killShip: (state, action) => {
            state.shipsStats[action.payload] = state.shipsStats[action.payload] - 1;
        },
        toInitialValues: state => {
            state.field = [];
            state.ships = [];
            state.shipsStats = {
                1: 4,
                2: 3,
                3: 2,
                4: 1
            };
        },
        continueGame: (state, action) => {
            state.field = action.payload.field;
            state.ships = action.payload.ships;
            state.shipsStats = action.payload.shipsStats;
        }
    }
});

export const { 
    createField,
    addShips,
    shot,
    hit,
    miss,
    mark,
    unmark,
    killShip,
    toInitialValues,
    continueGame
} = playerSlice.actions;

export const playerActions = playerSlice.actions;

export default playerSlice.reducer;